// extracted by mini-css-extract-plugin
export default {"wrapper":"PRXinput_wrapper__huB0u","line":"PRXinput_line__KzU8M","input":"PRXinput_input__8eNzN"};